import { observable, computed, action } from 'mobx'
import { getTextbook, getTags } from 'common/api'

export default class CardTable {
  @observable subjects = []     // 科目
  @observable ways = [          // 练习方式
    { id: 3, name: '套题' },
    { id: 1, name: '话题' },
    { id: 2, name: '题型' }
  ]
  @observable types = []        // 选择类型
  @observable categories = []   // 套题类型
  @observable cards = []        // 卡片

  @observable subjectIdx = 0              // 当前选择的 科目
  @observable wayIdx = 0                  // 当前选择的 练习方式
  @observable typeIdx = 0                 // 当前选择的 类型
  @observable categoryIdx = 0             // 当前选择的 套题类型

  @observable totalPage = 0       // 总页数
  @observable currentPage = 1     // 当前页数
  @observable loading = false     // 是否正在 load 数据

  @computed get currentSubject () {
    return this.subjects[this.subjectIdx] || null
  }

  @computed get currentWay () {
    return this.ways[this.wayIdx] || null
  }

  @computed get currentType () {
    return this.types[this.typeIdx] || null
  }

  @computed get currentCategory () {
    return this.categories[this.categoryIdx] || null
  }

  @action fetchTextbook (params) {
    this.loading = true
    getTextbook(params)
      .then(action('fetchTextbook end', data => {
        this.subjects = data.subjects
        this.types = []
        this.categories = data.categories
        this.cards = data.cards
        this.totalPage = data.totalPage

        this.loading = false
      }))
  }

  @action fetchTags (params) {
    this.loading = true
    getTags(params)
      .then(action('fetchTags end', data => {
        this.subjects = data.subjects
        this.types = data.types
        this.categories = []
        this.cards = data.cards
        this.totalPage = data.totalPage

        this.loading = false
      }))
  }

  @action resetData (examinationId) {
    this.subjectIdx = 0
    this.wayIdx = 0
    this.typeIdx = 0
    this.categoryIdx = 0
    this.totalPage = 0
    this.currentPage = 1

    this.fetchTextbook({ examinationId })
  }

  @action changeSubject (idx, params) {
    if (this.loading) { return }

    this.subjectIdx = idx
    this.wayIdx = 0
    this.typeIdx = 0
    this.categoryIdx = 0
    this.totalPage = 0
    this.currentPage = 1

    this.fetchTextbook(params)
  }

  @action changeWay (idx, params) {
    if (this.loading) { return }

    this.wayIdx = idx
    this.typeIdx = 0
    this.categoryIdx = 0
    this.totalPage = 0
    this.currentPage = 1

    if (this.ways[idx].id === 3) {
      // 练习方式为 套题
      this.fetchTextbook(params)
    } else {
      this.fetchTags(params)
    }
  }

  @action changeType (idx, params) {
    if (this.loading) { return }

    this.typeIdx = idx
    this.totalPage = 0
    this.currentPage = 1

    this.fetchTags(params)
  }

  @action changeCategory (idx, params) {
    if (this.loading) { return }

    this.categoryIdx = idx
    this.totalPage = 0
    this.currentPage = 1

    this.fetchTextbook(params)
  }

  @action changePage (page, params) {
    if (this.loading) { return }

    this.currentPage = page

    if (this.currentWay.id === 3) {
      // 练习方式为 套题
      this.fetchTextbook(params)
    } else {
      this.fetchTags(params)
    }
  }
}



/** WEBPACK FOOTER **
 ** ./src/models/CardTable.js
 **/